import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, NavigationExtras } from '@angular/router';
import { Message } from 'primeng/primeng';

import { HomeService } from '../home/home.service';
import { MainService } from '../main.service';
import { environment } from '../../environments/environment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})

export class ChangePasswordComponent implements OnInit {

  loginData: any;
  options: {};
  activityOptions: {};
  userOptions: {};
  message: string;
  username: string;
  password: string;
  session: string;
  imageData: string;
  activityResponce: any;
  dataResponce: any;
  msgs: Message[];
  growl: Message[];
  date = new Date();
  isClient: boolean;
  clickedOnce: boolean;

  currentPassword: string;
  newPassword: string;
  reEnterPassword: string;
  userEmail = localStorage.getItem('userEmail');

  currentDate = new Date();
  year = this.currentDate.getFullYear();
  token: {};

  setMessage() {
    this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
  }

  /////////////////  hard coded user login

  // loginDetails() {
  //   this.loginData = {};
  //   console.log("this.username", this.username);
  //   console.log("this.password", this.password);

  //   this.loginData.session="Abcdedfghijklmnopqrstuvwxyz12345";

  //   localStorage.setItem('isTour', 'false');
  //   if(this.username == "test@123.com" && this.password == "test"){
  //     if (this.loginData.session != undefined) {
  //       localStorage.setItem('jiraSession', JSON.stringify(this.loginData.session.value));
  //       localStorage.setItem("fromDate", "");
  //       localStorage.setItem("toDate", "");
  //       localStorage.setItem("component", "");
  //       this.session = this.loginData.session.value;
  //       // this.userMetaData(this.session);
  //       localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
  //       localStorage.setItem('userEmail', 'isuru.dissanayake@directfn.com');
  //       localStorage.setItem("sessionExpireTime", "");

  //       this.setMessage();

  //       this.authServiceReq();

  //     }
  //     else if (this.loginData.errorMessages[0] == 'Login denied') {

  //       this.clickedOnce = false;
  //       this.growl = [];
  //       this.growl.push({ severity: 'warn', summary: 'Login denied', detail: 'CAPTCHA CHALLENGE :  Please Log Out & Re-Login In \' JIRA \' and Try Again !' });
  //     }
  //     else if (this.loginData.errorMessages[0] == 'Login failed') {

  //       this.clickedOnce = false;
  //       this.growl = [];
  //       this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
  //     }
  //   }

  // }

  /////////// using database user login

  loginDetails() {

    this.mainService.authExternalUser(this.options).then(login => {
      this.loginData = login[0];

      if(this.loginData.sessionId != undefined){
        localStorage.setItem('jiraSession', this.loginData.sessionId);
        localStorage.setItem("fromDate", "");
        localStorage.setItem("toDate", "");
        localStorage.setItem("component", "");
        this.session = this.loginData.sessionId;
        // this.userMetaData(this.session);
        localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
        localStorage.setItem('userEmail', this.loginData.email);
        localStorage.setItem("sessionExpireTime", "");

        localStorage.setItem('externalUser', 'true');
        
        this.setMessage();

      }else if (this.loginData.errorMessage == 'Login Denied') {
        console.log("Login denied");
        this.clickedOnce = false;
        this.growl = [];
        this.growl.push({ severity: 'warn', summary: 'Login Denied', detail: 'CAPTCHA CHALLENGE :  Please Contact Admin or Re-Login and Try Again !' });
      }
      else if (this.loginData.errorMessage == 'Login Failed') {
        console.log("Login failed");
        this.clickedOnce = false;
        this.growl = [];
        this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
      }

      // if (this.loginData === undefined) {
      //   // Your code logic when this.loginData is undefined
      //   console.log("this.loginData is undefined");
      // } else {
      //   // Your code logic when this.loginData is defined
      //   console.log("this.loginData is defined");
      // }
    });

    // localStorage.setItem('isTour', 'false');
    // console.log(this.isClient);
    // if (!this.isClient) {
    //   this.mainService.clientLogin(this.options).then(login => {
    //     if (login.length == 1) {
    //       localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
    //       localStorage.setItem('userEmail', login[0].name);
    //       localStorage.setItem('userName', login[0].name);
    //       localStorage.setItem('login', 'true');

    //       this.setMessage();

    //       this.authServiceReq();

    //     } else {

    //       this.growl = [];
    //       this.growl.push({ severity: 'error', summary: 'Invalid Login' });
    //     }
    //   });

    // } else {
    //   this.mainService.userLogin(this.options).then(login => {
    //     this.loginData = login;

    //     if (this.loginData.session != undefined) {
    //       localStorage.setItem('jiraSession', JSON.stringify(this.loginData.session.value));
    //       localStorage.setItem("fromDate", "");
    //       localStorage.setItem("toDate", "");
    //       localStorage.setItem("component", "");
    //       this.session = this.loginData.session.value;
    //       // this.userMetaData(this.session);
    //       localStorage.setItem('sessionCreatedTime', String(this.date.getTime()));
    //       localStorage.setItem('userEmail', this.username);
    //       localStorage.setItem("sessionExpireTime", "");

    //       this.setMessage();

    //       this.authServiceReq();

    //     }
    //     else if (this.loginData.errorMessages[0] == 'Login denied') {

    //       this.clickedOnce = false;
    //       this.growl = [];
    //       this.growl.push({ severity: 'warn', summary: 'Login denied', detail: 'CAPTCHA CHALLENGE :  Please Log Out & Re-Login In \' JIRA \' and Try Again !' });
    //     }
    //     else if (this.loginData.errorMessages[0] == 'Login failed') {

    //       this.clickedOnce = false;
    //       this.growl = [];
    //       this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'Please Check Login Credentials !!' });
    //     }
    //   });
    // }

  }


  login() {
    this.message = 'Trying to log in ...';

    

    this.options = {
        lg: this.userEmail,
        cp: this.currentPassword,
        nps: this.newPassword
        // rps: this.reEnterPassword,
    };

    if(this.options['nps'] === this.reEnterPassword){
      this.mainService.updateAuthExternalUserPassword(this.options).then(login => {
        this.loginData = login[0].errorMessage;
        if(this.loginData === "Password Update Successfully"){
          this.growl = [];
          this.growl.push({ severity: 'success', summary: 'Password Update Successfully !! Please Log Again' });
          this.authService.logout();
          setTimeout(() => {
            this.router.navigate(['/ExternalLogin']);
          },
            1500);
          
        }
        else if(this.loginData === "Credential Wrong"){
          this.growl = [];
          this.growl.push({ severity: 'warn', summary: 'Login Denied', detail: 'Current Password Not Matched !!' });
        }
      });
    }else{
      this.growl = [];
      this.growl.push({ severity: 'error', summary: 'Login Failed', detail: 'New Passwords not Matching !!' });
    }

  }

  backToHome(){
    this.router.navigate(['/Home']);
  }


  constructor(public authService: AuthService, public router: Router, private mainService: MainService, private homeService: HomeService) {

  }

  ngOnInit() {
    // this.MSautho();
    // this.createLoginSessionInMicrosoft();
  }

}
